/** @type {Record<string, { title: string; responsibility: string; scheduleHuman: string; pipelineOrder: number; technicalId: string }>} */
export const CRON_JOB_META = {
  'basecamp-sync-orchestrator-daily': {
    title: 'Daily sync — coordinator',
    responsibility:
      'Creates sync batch and parent log at 06:00 UTC. Does not call Basecamp; per-account workers run on their own schedules.',
    scheduleHuman: 'Daily 06:00 UTC',
    pipelineOrder: 1,
    technicalId: 'basecamp-sync-orchestrator-daily',
  },
  'basecamp-sync-account-6068565': {
    title: 'Daily sync — Smart Media Group',
    responsibility: 'Syncs one org: all projects in DB; recordings and comments only for client-linked projects.',
    scheduleHuman: 'Daily 06:00 UTC',
    pipelineOrder: 2,
    technicalId: 'basecamp-sync-account-6068565',
  },
  'basecamp-sync-account-6084297': {
    title: 'Daily sync — Del Cielo Media',
    responsibility: 'Same pipeline as SMG. Runs at 06:02 UTC; skips OAuth refresh if the batch token is already fresh.',
    scheduleHuman: 'Daily 06:02 UTC',
    pipelineOrder: 3,
    technicalId: 'basecamp-sync-account-6084297',
  },
  'basecamp-sync-account-6084299': {
    title: 'Daily sync — Del Ray Media',
    responsibility: 'Same pipeline as SMG. Runs at 06:04 UTC; skips OAuth refresh if the batch token is already fresh.',
    scheduleHuman: 'Daily 06:04 UTC',
    pipelineOrder: 4,
    technicalId: 'basecamp-sync-account-6084299',
  },
  'basecamp-sync-stale-cleanup': {
    title: 'Sync health check',
    responsibility: 'Every 10 minutes: marks sync logs stuck in running for more than 15 minutes as failed.',
    scheduleHuman: 'Every 10 minutes',
    pipelineOrder: 5,
    technicalId: 'basecamp-sync-stale-cleanup',
  },
  'basecamp-sync-catchup': {
    title: 'Sync catch-up (incomplete checkpoints)',
    responsibility:
      'Every 2 hours: re-runs account sync for orgs where sync checkpoint phase is not idle (continues partial runs).',
    scheduleHuman: 'Every 2 hours',
    pipelineOrder: 5.5,
    technicalId: 'basecamp-sync-catchup',
  },
  'basecamp-agents-digest-daily': {
    title: 'Daily AI digest email',
    responsibility:
      '07:00 UTC: POSTs to basecamp-agents-run (pg_cron “Succeeded” = HTTP enqueue only). Pipeline runs when today’s sync batch is finished with ≥1 successful account; see Agents Logs → Cron for outcomes.',
    scheduleHuman: 'Daily 07:00 UTC',
    pipelineOrder: 6,
    technicalId: 'basecamp-agents-digest-daily',
  },
  'basecamp-sync-daily': {
    title: 'Daily Basecamp sync',
    responsibility: 'Scheduled account sync for connected Basecamp organizations.',
    scheduleHuman: 'Daily',
    pipelineOrder: 2,
    technicalId: 'basecamp-sync-daily',
  },
}

/**
 * @param {string} jobname
 */
export function cronMetaForJob(jobname) {
  const m = CRON_JOB_META[jobname]
  if (m) return m
  return {
    title: jobname,
    responsibility: '',
    scheduleHuman: '',
    pipelineOrder: 99,
    technicalId: jobname,
  }
}
